"use client";
import { cn } from "@/lib/utils/global-utils";
import React from "react";
import AccountAvatar from "./c-account-avatar";
import { LewkLogo } from "./c-logo";
import {buttonVariants } from "./ui/button";
import Link from "next/link";
import { useAuthProps } from "@/lib/utils/supabase/client";
import { Badge } from "./ui/badge";

interface HeaderProps
  extends React.HtmlHTMLAttributes<HTMLDivElement>,
    Partial<useAuthProps> {}

const Header = React.forwardRef<HTMLDivElement, HeaderProps>(
  ({ isLoggedIn = false, loading = true, user, className, ...rest }, ref) => {
    return (
      <div
        className={cn(
          "h-16 lg:h-20 w-full flex items-center justify-between bg-white border-b",
          className
        )}
        ref={ref}
        {...rest}
      >
        <div className=" flex items-center gap-2">
          <Link href={"/"}>
            <LewkLogo />
          </Link>

          <Badge variant={"light"}>Beta</Badge>
        </div>

        <div className=" flex gap-4 items-center">
          <Link
            className={buttonVariants({ variant: "secondary", size: "base" }) + "  hidden lg:inline-flex"}
            target="_blank"
            href={"https://www.shopthelewk.com/reportaproblem"}
          >
            Contact Us
          </Link>
          {isLoggedIn && user ? (
            <AccountAvatar
              email={user.email}
              profilePicURL={user.user_metadata.avatar_url}
            />
          ) : (
            <Link
              className={buttonVariants({ variant: "primary", size: "base" })}
              href={"/login"}
            >
              Login
            </Link>
          )}
        </div>
      </div>
    );
  }
);
export default Header;
